// extracted by mini-css-extract-plugin
export default {"overlay":"Pz-z","bodyOpen":"Qz-z","content":"Rz-z","header":"Sz-z","close":"Tz-z","closeNoHeading":"Uz-z"};